export const SetCustomerAddress = (
  address: string,
  subDistrict: string,
  district: string,
  province: string
) => {
  let customerAddress = address
  if (subDistrict) address += ' ' + subDistrict
  if (district) address += ' ' + district
  if (province) address += ' ' + province
  return customerAddress
}
